import React from 'react';

export const People = ({
  className,
  color,
}: {
  className?: string;
  color?: string;
}) => (
  <svg
    width="22"
    height="20"
    viewBox="0 0 22 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.3335 17.5V15.8333C14.3335 13.9924 12.8411 12.5 11.0002 12.5H5.16683C3.32588 12.5 1.8335 13.9924 1.8335 15.8333V17.5"
      stroke="#6B778C"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.08333 9.16667C9.92428 9.16667 11.4167 7.67428 11.4167 5.83333C11.4167 3.99238 9.92428 2.5 8.08333 2.5C6.24238 2.5 4.75 3.99238 4.75 5.83333C4.75 7.67428 6.24238 9.16667 8.08333 9.16667Z"
      stroke="#6B778C"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.667 6.66675V11.6667"
      stroke="#6B778C"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.167 9.16675H15.167"
      stroke="#6B778C"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
